import { autobind } from 'core-decorators';
import { observable } from 'mobx';
import { useEffect } from 'react';
import BaseStore from '@src/utils/store/base-store';
import routeConfigs from '@src/pages/app-router/route-configs';
import { ARTICLE_TITLE } from '@src/constants/articles';
import $$tracker from '@src/tracker';

class ListStore extends BaseStore {
  // 当前内页 articleId（来自路由 :id，借鉴上一届 articleId 路由管理，如 /list/11935）
  @observable activeId = null;

  /**
   * 跳转至指定内页（单路由 /list/:id，id 为文章 articleId）
   * @param {number|string} id - 内页 articleId
   */
  @autobind
  navToList(id) {
    $$tracker.clickMenu(ARTICLE_TITLE[id]);
    this.redirect(routeConfigs.LIST.path.replace(':id', id));
  }

  /**
   * 返回主页
   */
  @autobind
  backHome() {
    $$tracker.clickMenu('返回首页');
    this.redirect(routeConfigs.MAIN.path);
  }

  use() {
    super.use();

    this.activeId = this.$routeParams.id ? parseInt(this.$routeParams.id, 10) : null;

    // 进入内页后定位到「公共组件 - 导航」(屏幕 top 519) 上方约 50px 处。
    // 内容根用 min-height:200vh 保证进入时页面已足够高、滚动目标(469)立即可达并稳定落位，
    // CMS 内容随后只向下撑开（在视区下方），不会上移已看到的区域，从而避免与异步撑高叠加产生抖动
    // （对齐上一届处理：大 min-height + 进入即滚，不做额外的内容就绪回调）。
    useEffect(
      () => {
        if (this.activeId) {
          window.scrollTo({ top: 469, behavior: 'smooth' });
        }
      },
      [this.activeId]
    );
  }
}

export default ListStore;
